import { render, staticRenderFns } from "./battery-indicator.vue?vue&type=template&id=ee31e4a8&scoped=true&"
import script from "./battery-indicator.vue?vue&type=script&lang=js&"
export * from "./battery-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee31e4a8",
  null
  
)

export default component.exports